import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function YoutubeIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 6C16 6 25.3909 6.00037 27.7393 6.6416C29.0217 6.98939 30.0438 7.99981 30.3809 9.28223C31.0185 11.6167 31.0012 16.4661 31.001 16.5215C31.001 16.5215 31.0004 21.3913 30.3809 23.7393C30.033 25.0219 29.0219 26.033 27.7393 26.3809C25.3908 27.0003 16 27 16 27C15.939 27 6.62259 26.9986 4.26074 26.3594C2.97816 26.0115 1.96696 25.0004 1.61914 23.7178C0.999588 21.3916 1 16.5 1 16.5C1.00001 16.4622 1.00199 11.6209 1.61914 9.28223C1.96705 7.99976 2.99998 6.96696 4.26074 6.61914C6.60093 6.00159 15.9389 6.00001 16 6ZM13.0527 20.9951L20.8574 16.4951L13.0527 11.9951V20.9951Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
